import { defineMessages } from 'react-intl';

const trns = defineMessages({
  catalogLabel: {
    id: 'FCddpq',
    defaultMessage: 'Каталог ліків'
  },
  catalog: {
    id: 'Q98YxJ',
    defaultMessage: 'каталог'
  }
});

export default trns;
